type InnerPageHeroProps = {
  kicker: string;
  title: string;
};

export function InnerPageHero({ kicker, title }: InnerPageHeroProps) {
  return (
    <section className="page-hero inner-page-hero" aria-labelledby="page-title">
      <div className="content-width">
        <p className="breadcrumb">{kicker}</p>
        <div className="hero-copy">
          <h1 id="page-title">{title}</h1>
        </div>
      </div>
    </section>
  );
}
